import { diaryDetailSearchFields } from './fields'

export const diaryDetailSearchValidation = (data) => {
    return {
        initialValues: {
            [diaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID]: data?.[diaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID] ?? '',
            [diaryDetailSearchFields.FULL_NAME_SELLER]: data?.[diaryDetailSearchFields.FULL_NAME_SELLER] ?? '',
            [diaryDetailSearchFields.FULL_NAME_BUYER]: data?.[diaryDetailSearchFields.FULL_NAME_BUYER] ?? '',
            [diaryDetailSearchFields.LOCATION]: data?.[diaryDetailSearchFields.LOCATION] ?? '',
            [diaryDetailSearchFields.DIARY_DATE_FROM]: data?.[diaryDetailSearchFields.DIARY_DATE_FROM] ?? '',
            [diaryDetailSearchFields.DIARY_DATE_TO]: data?.[diaryDetailSearchFields.DIARY_DATE_TO] ?? '',
        },
    }
}
